module.exports = __webpack_public_path__ + "media/img/corporate/section2-b986c445cee1b18117f14de235af6f4a.svg";